import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {DOCUMENT} from "@angular/common";
import {takeUntil} from "rxjs/operators";
import {PasoWizard, WizardInformacion} from "../../interface/wizard-informacion.types";
import {DataWizardService} from '../../services/data-wizard.service';
import {WizardEventsService} from "../../services/wizard-events.service";
import {EvkSeccionModel} from "../../../expediente/models/evk-seccion.model";
import {DatosSeccionWizardEventsService} from "../../services/datos-seccion-wizard-events.service";
import {Router} from "@angular/router";
import { ButtonControlService } from '../../services/button-control.service';

@Component({
    selector: 'lib-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.css']
})
export class WizardComponent implements OnInit, OnDestroy {

    @Input()
    readOnly;

    informacionWizard: WizardInformacion;

    informacionGuardada;

    wizardSteps: PasoWizard[];

    informacionSeccion: EvkSeccionModel;

    currentStep: number = 0;
    beforeCurrentStep: number = 0;

    drawerMode: 'over' | 'side' = 'side';

    drawerOpened: boolean = true;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    @Output()
    backPage: EventEmitter<any> = new EventEmitter<any>();

    isLoading: string = "";
    @Input()
    biosphereConfig: any;

    @Input()
    descargaZipByFolio: boolean;

    @Input()
    skipByVersion: boolean;
    
    disableNext = true;

    /**
     * Constructor
     */
    constructor(
        @Inject(DOCUMENT) private _document: Document,
        private _changeDetectorRef: ChangeDetectorRef,
        private _elementRef: ElementRef,
        public dataWizardService: DataWizardService,
        public wizardEvents: WizardEventsService,
        public datosSeccionWizard: DatosSeccionWizardEventsService,
        public router: Router,
        private buttonControlService: ButtonControlService,
    ) {
    }

    /**
     * On init
     */
    ngOnInit(): void {
        this.obSerbarCambiosDataExpediente();
        this.suscripcionEventos();
        this.checkResolution();
        window.onresize = () => {
            if(screen.width < 1280){
                this.drawerMode = 'over';
                this.drawerOpened = false;
            }
            else{
                this.drawerMode = 'side';
                this.drawerOpened = true;
            }
        }
        this.buttonControlService.botonSiguiente.subscribe(response => {
            this.disableNext = !response;
        })
    }

    public obSerbarCambiosDataExpediente() {
        this.dataWizardService.dataWizard.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
            this.informacionWizard = response;
            if (response.pasos) {
                this.wizardSteps = response.pasos;
            }
        });
    }

    suscripcionEventos() {
        this.datosSeccionWizard.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe((response) => {
            this.informacionSeccion = response;
        });

        this.wizardEvents.onSave.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            const pasoGuardar = this.wizardSteps[this.currentStep];

            if (this.informacionSeccion && this.informacionSeccion.origen == pasoGuardar.nombre) {
                pasoGuardar.inData = this.informacionSeccion.propiedades;
                pasoGuardar.outData = this.informacionSeccion.propiedades;
            } else {
                pasoGuardar.outData = pasoGuardar.inData;
            }
            this.wizardEvents.doneSave(this.wizardSteps, pasoGuardar);
        })
        this.wizardEvents.goToStepNameEvent.pipe(takeUntil(this._unsubscribeAll)).subscribe( nombre => {
            const orden = this.informacionWizard.pasos.findIndex(paso => paso.nombre === nombre);
            if (orden != -1) {
                this.goToStep(orden, false);
            }
        });
    }


    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    /**
     * Go to given step
     *
     * @param step
     */
    goToStep(step: number, isToPreviousStep: boolean): void {

        // Set before current step
        this.beforeCurrentStep = this.currentStep;
        try {
            if (isToPreviousStep === false) {
                this.guardarWizardEvent().subscribe(() => {
                    this.isLoading = "";
                    // Set the current step
                    this.currentStep = step;
                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                });
            } else {
                this.isLoading = "";
                this.currentStep = step;
                // Mark for check
                this._changeDetectorRef.markForCheck();
            }
        } catch (error) {
            this.isLoading = "";
        }
    }

    /**
     * Go to previous step
     */
    goToPreviousStep(): void {
        // Return if we already on the first step
        if (this.currentStep === 0) {
            return;
        }

        this.isLoading = "back";
        // Go to step
        this.goToStep(this.currentStep - 1, true);

        // Scroll the current step selector from sidenav into view
        this._scrollCurrentStepElementIntoView();
    }

    /**
     * Go to next step
     */
    goToNextStep(): void {
        // Return if we already on the last step
        if (this.currentStep === this.informacionWizard.totalPasos - 1) {
            return;
        }
        this.isLoading = "go";
        // Go to step
        this.goToStep(this.currentStep + 1, false);

        // Scroll the current step selector from sidenav into view
        this._scrollCurrentStepElementIntoView();
    }

    guardarWizardEvent(evento?: string): Observable<any> {
        return new Observable((observer) => {
            const folio = {
                generarFolio: this.wizardSteps[this.currentStep].generarFolio,
                ultimoPaso: evento == 'Finalizar'
            }
            this.wizardEvents.generateFolio(folio);
            this.wizardEvents.save();
            this.wizardEvents.onNextOrSave.pipe(takeUntil(this._unsubscribeAll)).subscribe((response) => {
                observer.next(response);
            }, (e) => {
                console.log(e);
            });
            this.wizardEvents.onError.pipe(takeUntil(this._unsubscribeAll)).subscribe((response) => {
                this.isLoading = "";
                observer.error(response);
            }, (e) => {
                this.isLoading = "";
            });
        });
    }

    goToSave(): void {
        this.isLoading = "go";
        this.guardarWizardEvent('Finalizar').subscribe(() => {
            this.wizardEvents.goToFinish();
            this.isLoading = "";
        });
    }

    back(){
        this.backPage.next();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Scrolls the current step element from
     * sidenav into the view. This only happens when
     * previous/next buttons pressed as we don't want
     * to change the scroll position of the sidebar
     * when the user actually clicks around the sidebar.
     *
     * @private
     */
    private _scrollCurrentStepElementIntoView(): void {
        // Wrap everything into setTimeout so we can make sure that the 'current-step' class points to correct element
        setTimeout(() => {

            // Get the current step element and scroll it into view
            const currentStepElement = this._document.getElementsByClassName('current-step')[0];
            if (currentStepElement) {
                currentStepElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    }

    public checkResolution(){
        if(screen.width < 1280){
            this.drawerMode = 'over';
            this.drawerOpened = false;
        }
        else{
            this.drawerMode = 'side';
            this.drawerOpened = true;
        }
    }

}
